import Tag from '../../../../../services/tag';
import Vehicles from '../../../../../services/vehicles';

export default {
  props: ['vehicle', 'completeData'],
  data() {
    return {
      activetagLoading: undefined,
      serialNumber: undefined,
      promise: undefined,
      linkedTag: false,
      vehicles: undefined,
      msg: undefined
    }
  },
  methods: {
    vincularTag() {

      if(this.serialNumber.replace(/^[^0-9]*/g, '').trim().length == 0) {
        this.msg = 'Número de TAG inválido.';
        this.linkedTag = 'error';
        return;
      }

      let request = {
        serialNumber: parseInt(this.serialNumber.replace(/^[^0-9]*/g, '')),
        vehicleId: this.vehicle.vehicleId,
        moveMaisId: this.vehicle.moveMaisId
      };

      this.promise = this.$validator.validateAll().then(success => {
        return success && Tag.activateTagGeneral(request);
      }).then( response => {
        if(response.response == "OK"){
          this.linkedTag = 'success';
        } else {
          this.linkedTag = 'error';
          this.msg = response.response;
        }
      }).catch((error) => {
        this.msg = error.data.status.message;
        if (error.msg && error.msg.includes('[vee-validate]')) {
          return false;
        }

        this.$emit('deactivatetagLoading');
        this.linkedTag = 'error';
      });

      this.$emit('activetagLoading', this.promise);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/aggregate-register/tag.js